(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("rp-analytics"));
	else if(typeof define === 'function' && define.amd)
		define(["rp-analytics"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("rp-analytics")) : factory(root["rp-analytics"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = initBookmakerRegPanel;

var _rpAnalytics = __webpack_require__(1);

var SegmentIO = _interopRequireWildcard(_rpAnalytics);

__webpack_require__(0);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function initBookmakerRegPanel() {
    var openedBookmakerClass = 'rh-bookmaker--open';
    var hiddenPanelClass = 'rh-bookmakers--hidden';
    var isMobile = /iPhone|Android|BlackBerry|Opera Mini|IEMobile/i.test(navigator.userAgent);

    if (isMobile) {
        Array.from(document.querySelectorAll('.rh-bookmakers__list--web')).forEach(function (webBookmakersNode) {
            return webBookmakersNode.remove();
        });
    }

    Array.from(document.querySelectorAll('.rh-bookmakers .rh-bookmakers__heading--mobile')).forEach(function (mobileHeaderNode) {
        return mobileHeaderNode.addEventListener('click', function () {
            var bookmakersNode = mobileHeaderNode.parentNode.parentNode;

            if (bookmakersNode.classList.contains(hiddenPanelClass)) {
                bookmakersNode.classList.remove(hiddenPanelClass);

                SegmentIO.trackOfferAccordionOpened(_defineProperty({}, SegmentIO.TRAIT_ACCORDION_NAME, 'Today\'s Bookmaker Offers'));

                return;
            }

            bookmakersNode.classList.add(hiddenPanelClass);

            SegmentIO.trackOfferAccordionClosed(_defineProperty({}, SegmentIO.TRAIT_ACCORDION_NAME, 'Today\'s Bookmaker Offers'));
        });
    });

    Array.from(document.querySelectorAll('.rh-bookmakers .rh-bookmaker__header')).forEach(function (headerNode) {
        return headerNode.addEventListener('click', function () {
            var _SegmentIO$trackOffer4;

            var openedBookmakerNodes = document.getElementsByClassName(openedBookmakerClass);
            var bookmakerNode = headerNode.parentNode;
            var isBookmakerNodeOpened = bookmakerNode.classList.contains(openedBookmakerClass);
            var index = Number(bookmakerNode.getAttribute('data-index')) + 1;

            if (openedBookmakerNodes.length > 0) {
                Array.from(openedBookmakerNodes).forEach(function (node) {
                    var offerLabel = node.querySelector('.rh-bookmaker__view-offer>span');
                    offerLabel.innerHTML = 'View offer';
                    node.classList.remove(openedBookmakerClass);
                });
            }

            if (!isBookmakerNodeOpened) {
                var _SegmentIO$trackOffer3;

                bookmakerNode.classList.add(openedBookmakerClass);
                SegmentIO.trackOfferAccordionOpened((_SegmentIO$trackOffer3 = {}, _defineProperty(_SegmentIO$trackOffer3, SegmentIO.TRAIT_ACCORDION_NAME, bookmakerNode.getAttribute('data-name')), _defineProperty(_SegmentIO$trackOffer3, SegmentIO.TRAIT_POSITION, index), _SegmentIO$trackOffer3));
                bookmakerNode.querySelector('.rh-bookmaker__view-offer>span').innerHTML = 'Hide offer';

                return;
            }

            SegmentIO.trackOfferAccordionClosed((_SegmentIO$trackOffer4 = {}, _defineProperty(_SegmentIO$trackOffer4, SegmentIO.TRAIT_ACCORDION_NAME, bookmakerNode.getAttribute('data-name')), _defineProperty(_SegmentIO$trackOffer4, SegmentIO.TRAIT_POSITION, index), _SegmentIO$trackOffer4));
        });
    });

    Array.from(document.querySelectorAll('.rh-bookmaker-offer__claim-btn')).forEach(function (el) {
        return el.addEventListener('click', function () {
            var _SegmentIO$trackBetti;

            SegmentIO.trackBettingOfferClick((_SegmentIO$trackBetti = {}, _defineProperty(_SegmentIO$trackBetti, SegmentIO.TRAIT_BOOKMAKER, el.getAttribute('data-name')), _defineProperty(_SegmentIO$trackBetti, SegmentIO.TRAIT_LOCATION, 'Panel'), _defineProperty(_SegmentIO$trackBetti, SegmentIO.TRAIT_POSITION, Number(el.getAttribute('data-index')) + 1), _SegmentIO$trackBetti));
        });
    });
}

/***/ })
/******/ ]);
});
//# sourceMappingURL=rpbettingspecialoffer.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rp-betting-special-offer/lib/rpbettingspecialoffer.js
// module id = 670
// module chunks = 0